var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isSplitbar)?_c('div',{staticClass:"splitbar"}):_c('button',{class:_vm.computeClass(),attrs:{"id":_vm.id,"title":_vm.title,"disabled":_vm.isDisabled},on:{"click":function($event){return _vm.onClick()}}})}
var staticRenderFns = []

export { render, staticRenderFns }